export default __webpack_public_path__ + "static/media/559.6a76b95a.jpg";